import { ListingOfferCardHorizontal } from 'app/components/listing-card-horizontal.large';
import { ListingOfferCard } from 'app/components/listing-offer-card';
import { ListingList } from 'app/components/listing-list';
import React from 'react';
import type { ProfileListingResults } from './shared';
import { ProfileListingEmpty } from './profile-listing-empty';

export function NeighbourOffers({
  isLargeUI,
  results,
  searchQuery,
  setSearchQuery,
}: {
  isLargeUI: boolean;
  results: ProfileListingResults;
  searchQuery: string;
  setSearchQuery: React.Dispatch<React.SetStateAction<string>>;
}) {
  return (
    <ListingList
      filters={results.filters}
      data={results.listings}
      isLoading={results.isLoading}
      isFetchingNextPage={results.query.isFetchingNextPage}
      numListingsTotal={results.total}
      onRefresh={results.query.resetThenRefetch}
      refreshing={results.query.isRefetching}
      byPassFixedHeight
      scrollEnabled={false}
      searchQuery={searchQuery}
      onSearchQueryChange={setSearchQuery}
      card={isLargeUI ? ListingOfferCardHorizontal : ListingOfferCard}
      listFormat={isLargeUI ? 'list' : 'grid'}
      horizontalGap="spacing.general.x2"
      presentation={{ padding: 'page', requestBanner: 'hidden', searchBar: 'visible', user: 'hidden' }}
      ListEmptyComponent={<ProfileListingEmpty translationKey="place.noListingsOffer" />}
    />
  );
}
